import React from 'react';
import styled from 'styled-components';
import { useAccount, useChainId } from 'wagmi';
import WalletConnect from '../WalletConnect';
import { useDisconnect } from 'wagmi';
import { SUPPORTED_CHAINS } from '../../utils/relayProtocol';

// Monad Brand Colors
const MONAD_PURPLE = '#836EF9';
const MONAD_BLUE = '#200052';
const MONAD_BERRY = '#A0055D';
const MONAD_BLACK = '#0E100F';
const MONAD_OFF_WHITE = '#FBFAF9';

const NavigationBar = styled.div`
  width: 100%;
  background: #000000;
  border-bottom: 1px solid rgba(131, 110, 249, 0.2);
  position: sticky;
  top: 0;
  z-index: 100;
`;

const NavigationContainer = styled.div`
  width: 100%;
  padding: 16px 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  
  @media (max-width: 768px) {
    padding: 12px 15px;
    gap: 12px;
  }
`;

const LogoSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  
  @media (max-width: 700px) {
    flex: 1;
  }
`;

const MonadLogo = styled.img`
  height: 40px;
  width: auto;
  object-fit: contain;
  
  @media (max-width: 700px) {
    height: 32px;
  }
`;

const WalletSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const WalletBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: rgba(131, 110, 249, 0.1);
  border: 1px solid rgba(131, 110, 249, 0.3);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover {
    background: rgba(131, 110, 249, 0.2);
    border-color: rgba(131, 110, 249, 0.5);
  }
`;

const ChainLogo = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid rgba(131, 110, 249, 0.3);
  object-fit: cover;
`;

const AddressText = styled.span`
  color: ${MONAD_OFF_WHITE};
  font-size: 14px;
  font-weight: 500;
  font-family: 'Inter', monospace;
  
  @media (max-width: 700px) {
    font-size: 12px;
  }
`;


const MonadNavBar: React.FC = () => {
  const { isConnected, address } = useAccount();
  const chainId = useChainId();
  const { disconnect } = useDisconnect();
  
  // Function to get current chain logo - always show Monad logo on Monad pages
  const getCurrentChainLogo = () => {
    // Always show Monad logo on Monad pages, or if connected to Monad chain
    if (chainId === 143) {
      // Try Relay API first, fallback to llamao.fi, then local file
      return 'https://icons.llamao.fi/icons/chains/rsz_monad.jpg';
    }
    // If on different chain but on Monad page, still show Monad logo
    const chain = Object.values(SUPPORTED_CHAINS).find(chain => chain.chainId === chainId);
    // Default to Monad logo since we're on Monad pages
    return chain?.logo || 'https://icons.llamao.fi/icons/chains/rsz_monad.jpg';
  };

  return (
    <NavigationBar>
      <NavigationContainer>
        <LogoSection onClick={() => window.location.href = '/monad'}>
          <MonadLogo src="/monad-logo-nav-bar.png" alt="Monad" />
        </LogoSection>

        <WalletSection>
          {isConnected && address && (
            <>
              <WalletBadge onClick={() => disconnect()} title="Click to disconnect wallet">
                <AddressText>
                  {address.slice(0, 6)}...{address.slice(-4)}
                </AddressText>
              </WalletBadge>
              <ChainLogo src={getCurrentChainLogo()} alt="Current Chain" />
            </>
          )}
          {!isConnected && <WalletConnect />}
        </WalletSection>
      </NavigationContainer>
    </NavigationBar>
  );
};

export default MonadNavBar;

